import React, { useMemo } from 'react';
import clsx from 'clsx';
import style from '../styles/buttons.module.css';
import { BaseCloseButton } from '../../button';
import { useHintContext } from '../hint-provider';
/**
 * `<HintCloseButton />`  - Кнопка закрытия Хинта.
 * Логика закрытия прописывается пользователем в пропс onClick.
 *
 * @example ``` tsx
<HintCloseButton onClick={() => setIsOpen(false)} />
 * ```
 */

export const HintCloseButton = ({
  className,
  tabIndex: externalTabIndex,
  ...props
}) => {
  const buttonClassName = useMemo(() => clsx(style.closeButton, className), [className]);
  const {
    open
  } = useHintContext();
  const tabIndex = externalTabIndex != null ? externalTabIndex : open ? 0 : -1;
  return /*#__PURE__*/React.createElement(BaseCloseButton, {
    invert: true,
    "aria-label": "close",
    "data-testid": "hint-button-close",
    className: buttonClassName,
    tabIndex: tabIndex,
    ...props
  });
};